<template>
  <div :class="'piece piece-' + piece.id" class="col-sm-12">
    <input type="hidden" :name="'pieces[' + pieceIndex + '][id]'" :value="piece.id" />

    <input v-if="changed" type="hidden" :name="'pieces[' + pieceIndex + '][data][changed]'" :value="changed" />

    <div v-if="piece.options.input_type === 'locked'">
      <locked-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
      ></locked-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'hidden'">
      <hidden-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :advanced-email-options="advancedEmailOptions"
      ></hidden-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'text'">
      <text-piece
        :piece-id="piece.id"
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
        @content-change="onContentChange($event)"
        @disable-saving="$emit('disable-saving', $event)"
      ></text-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'textarea'">
      <textarea-piece
        :piece-id="piece.id"
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
        :step-activity-type="stepActivityType"
        @content-change="onContentChange($event)"
        @disable-saving="$emit('disable-saving', $event)"
      ></textarea-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'html'">
      <html-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
      ></html-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'html_fullpage'">
      <html-fullpage-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
      ></html-fullpage-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'select'">
      <select-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
        :piece-data="piece.data"
      ></select-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'subscribing_campaigns_piece'">
      <subscribing-campaigns-piece
        :campaign-id="campaignId"
        :piece="piece"
        :step-id="stepId"
      ></subscribing-campaigns-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'image_selector'">
      <image-selector-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
        :piece-data="piece.data"
      ></image-selector-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'image'">
      <image-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
      ></image-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'theme_image'">
      <theme-image-piece
        :campaign-id="campaignId"
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
        :piece-data="piece.data"
        :first-step-id="firstStepId"
      ></theme-image-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'document'">
      <document-piece
        :step-id="stepId"
        :piece-id="piece.id"
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-data="piece.data ? piece.data : {}"
        :piece-options="piece.options"
        :piece-order="piece.order"
        @disable-saving="$emit('disable-saving', $event)"
      ></document-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'theme'">
      <theme-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
        :piece-data="piece.data"
      ></theme-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'date'">
      <date-piece
        :piece-index="pieceIndex"
        :piece-name="piece.name"
        :piece-content="piece.content"
        :piece-options="piece.options"
      ></date-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'script'">
      <script-piece :piece-index="pieceIndex" :piece="piece"></script-piece>
    </div>
    <div v-else-if="piece.options.input_type === 'oembed'">
      <embed-piece
        :piece-index="pieceIndex"
        :piece="piece"
        @disable-saving="$emit('disable-saving', $event)"
      ></embed-piece>
    </div>
  </div>
</template>

<script>
import HiddenPiece from './pieces/HiddenPiece';
import LockedPiece from './pieces/LockedPiece';
import TextPiece from './pieces/TextPiece';
import TextareaPiece from './pieces/TextareaPiece';
import HtmlPiece from './pieces/HtmlPiece';
import HtmlFullpagePiece from './pieces/HtmlFullpagePiece';
import SelectPiece from './pieces/SelectPiece';
import ImagePiece from './pieces/ImagePiece';
import ImageSelectorPiece from './pieces/ImageSelectorPiece';
import ThemeImagePiece from './pieces/ThemeImagePiece';
import ThemePiece from './pieces/ThemePiece';
import DocumentPiece from './pieces/DocumentPiece';
import DatePiece from './pieces/DatePiece';
import ScriptPiece from './pieces/ScriptPiece';
import EmbedPiece from './pieces/EmbedPiece';
import SubscribingCampaignsPiece from './pieces/SubscribingCampaignsPiece';

export default {
  name: 'step-piece',
  components: {
    TextareaPiece,
    HtmlPiece,
    HtmlFullpagePiece,
    DatePiece,
    ThemePiece,
    DocumentPiece,
    ThemeImagePiece,
    ImagePiece,
    ImageSelectorPiece,
    TextPiece,
    LockedPiece,
    SelectPiece,
    HiddenPiece,
    ScriptPiece,
    EmbedPiece,
    SubscribingCampaignsPiece,
  },
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    piece: {
      type: Object,
      required: true,
    },
    pieceIndex: {
      type: Number,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
    stepActivityType: {
      type: String,
      required: true,
    },
    firstStepId: {
      type: Number,
      required: true,
    },
    advancedEmailOptions: {
      type: Boolean,
    },
  },
  data() {
    return {
      changed: false,
      originalContent: null,
    };
  },
  watch: {
    changed: {
      immediate: true,
      handler(changed) {
        if (this.requiresChange(this.piece)) {
          this.$emit('disable-saving', {
            disabled: !changed,
            pieceId: this.piece.id,
            message: `You need to change the default value in the ${this.piece.name} field.`,
          });
        }
      },
    },
    piece: {
      immediate: true,
      handler(piece) {
        this.originalContent = piece.content;

        if (this.requiresChange(piece)) {
          this.changed = this.changed || Boolean(piece.data?.changed ?? piece.options.changed);
        }
      },
    },
  },
  methods: {
    onContentChange(content) {
      this.changed = content !== this.originalContent;
    },
    requiresChange(piece) {
      return piece && piece.options && piece.options.required === 'change';
    },
  },
};
</script>

<style lang="scss" scoped></style>
